import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router';

import Icon from 'components/Icon';

const Collapse = props => {
  const { theme, title, children } = props;
  const [collapsed, setCollapsed] = useState(true);

  const onToggle = () => setCollapsed(!collapsed);

  return (
    <div className={classNames(theme.collapseBox, collapsed && theme.sectionCollapsed)}>
      <Link className={theme.listTitle} onClick={onToggle} role="button">
        <span>{title}</span>
        <Icon size="medium-large" color="white" icon="add" className={theme.plus} />
      </Link>
      {children}
    </div>
  );
};

export default Collapse;

Collapse.propTypes = {
  children: PropTypes.shape({}),
  theme: PropTypes.shape({}),
  title: PropTypes.string,
};
